// extracted by mini-css-extract-plugin
export default {"home":"Home_home__m+Y9x","cards":"Home_cards__Pf6dN","budget":"Home_budget__vMFxW","category":"Home_category__RQHOG"};